import VueDatepicker from '@ui-common/vue-datepicker';
import moment from 'moment';
const DATE_PICKER_CLOSE_GTM_EVENT = 'datePickerSelect';
const DATE_PICKER_GTM_DATE_FORMAT = 'YYYY-MM-DD';
const DATE_PICKER_GTM_DATE_FORMAT_NO_DAY = 'YYYY-MM';
export default {
	extends: VueDatepicker,
	created() {
		this.$on('blur', () => {
			const currentDate = moment([this.selectedYear, this.selectedMonth, this.selectedDay]);
			if (!this.isCalendarOpen && currentDate.isValid()) {
				this.$gtm.trackEvent({
					event: DATE_PICKER_CLOSE_GTM_EVENT,
					formElementID: document.querySelector(`label[for=${this.$refs['datepicker-input'].id}]`).innerHTML,
					formID: this.$refs['datepicker-input'].form && this.$refs['datepicker-input'].form.getAttribute('id') || '',
					inputValue: currentDate.format(this.monthSelectOnly ? DATE_PICKER_GTM_DATE_FORMAT_NO_DAY : DATE_PICKER_GTM_DATE_FORMAT)
				});
			}
		});
	}
};
